"use strict";

define('model/docstore',['require','exports','module','./base','./upload','underscore'],function (require, exports, module) {
  var BaseModel = require('./base');
  var UploadModel = require('./upload');
  var _ = require('underscore');
  module.exports = BaseModel.extend({
    urlRoot: '/rs/api/docstore',
    childModels: {
      createPerson: 'Person'
    },
    virtual: {
      url: function url() {
        return this.urlRoot + '/' + encodeURIComponent(this.id);
      }
    },
    parse: function parse() {
      var data = BaseModel.prototype.parse.apply(this, arguments);
      if (_.isArray(data)) {
        return data[0];
      }
      return data;
    },
    update: function update() {
      return BaseModel.prototype.sync('update', this).then(function (response) {
        if (response.error) {
          this.trigger('error', this, response.error);
        } else {
          this.trigger('sync');
        }
      }.bind(this));
    }
  }, {
    IMAGE_UPLOAD_URL: '/rs/api/form/docstore/image',
    IMAGE_UPLOAD_URL_WITH_DOC: '/rs/api/form/docstore/image/:documentId',
    STUDY_ATTACHMENT_URL: '/rs/api/study/docstore/:studyId',
    MEETING_ATTACHMENT_URL: '/rs/api/meeting/docstore/:meetingId',
    DOCSTORE_DELETE_URL: '/rs/api/docstore/:id',
    DOCSTORE_UPDATE_URL: '/rs/api/docstore/:id',
    DOCSTORE_APPLY_STAMPS_URL: '/rs/api/docstore/stamp',
    createUploadCollection: function createUploadCollection(url, files) {
      return UploadModel.createCollection(url, files, this);
    },
    buildUploadHandler: function buildUploadHandler(app, attachmentUrl, uploadParams, uploadCompleteHandler) {
      var uploadFiles = function (files) {
        var uploads = this.createUploadCollection(attachmentUrl, files).params(uploadParams).on('upload:complete', function () {
          uploadCompleteHandler();
        });
        app.request('file:upload', uploads);
      }.bind(this);
      return function () {
        app.request('file:chooser', {
          multiple: true,
          callback: uploadFiles
        });
      };
    }
  });
});

